module.exports = __webpack_public_path__ + "img/Mao1.36461d2b.png";